// components/BatchTables/JobListTable.jsx
import React from "react";
import {
	Typography,
	TextField,
	FormControl,
	Select,
	MenuItem,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Button,
	Box,
	Pagination,
	
} from "@mui/material";

const ExecDtlTable = ({
	searchQueryJobExec,
	setSearchQueryJobExec,
	rowsPerPageJobExec,
	handleChangeRowsPerPageJobExec,
	anchorEl,
	closeFilter,
	filters,
	setFilters,
	filteredJobExec,
	paginatedProcessesJobExec,
	handleJobClickJobExec,
	totalPagesJobExec,
	pageJobExec,
	handleChangePageJobExec,
	handleBackJobExec,
	item,
	jobExecDtl
}) => {
	console.log("rowsPerPageJobExec:", rowsPerPageJobExec); 
	return (
		<>
			<Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
				Details for Job Execution
			</Typography>

			<TextField
				size="small"
				label="Search"
				value={searchQueryJobExec}
				onChange={(e) => setSearchQueryJobExec(e.target.value)}
				sx={{ flex: 1, mr: 2 }}
			/>

			<div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
				<Typography variant="body1">Rows per page:</Typography>
				<FormControl size="small">
					<Select value={rowsPerPageJobExec} onChange={handleChangeRowsPerPageJobExec}>
						<MenuItem value={10}>10</MenuItem>
						<MenuItem value={50}>50</MenuItem>
						<MenuItem value={100}>100</MenuItem>
					</Select>
				</FormControl>
			</div>


			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: "bold" }}>Property</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Value</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{jobExecDtl?.item && (
							<React.Fragment>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold', width: '30%' }}>Exit Code</TableCell>
									<TableCell>{jobExecDtl.item.lastExecStts ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>ID Status</TableCell>
									<TableCell>{jobExecDtl.item.lastRunStts ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Job Execution Duration</TableCell>
									<TableCell>{jobExecDtl.item.lastExecDuration ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Job ID</TableCell>
									<TableCell>{jobExecDtl.item.runNum ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Job Instance ID</TableCell>
									<TableCell>{jobExecDtl.item.runNum ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Job Name</TableCell>
									<TableCell>{jobExecDtl.item.batchName ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Job Param</TableCell>
									<TableCell>{jobExecDtl.item.jobParam ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Start Date</TableCell>
									<TableCell>{jobExecDtl.item.lastExecDate ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Start Time</TableCell>
									<TableCell>{jobExecDtl.item.lastExecStart ?? ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell sx={{ fontWeight: 'bold' }}>Step Executions Count</TableCell>
									<TableCell>{jobExecDtl.item.exeCnt ?? ''}</TableCell>
								</TableRow>
							</React.Fragment>
						)}
					</TableBody>
				</Table>
			</TableContainer>


			<Box display="flex" justifyContent="right" mt={3}>
				<Pagination
					count={totalPagesJobExec}
					page={pageJobExec}
					onChange={handleChangePageJobExec}
					color="primary"
					showFirstButton
					showLastButton
				/>
			</Box>

			<Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
				Details for Job Execution
			</Typography>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: "bold" }}>Step Name</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Reads</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Writes</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Commits</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Rollbacks</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Job Execution Duration</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{Array.isArray(jobExecDtl?.stepExecDtls) && jobExecDtl.stepExecDtls.length > 0 ? (
							jobExecDtl.stepExecDtls.map((step, index) => (
								<TableRow key={index}>
									<TableCell>{step.stepName ?? ''}</TableCell>
									<TableCell>{step.readCnt ?? ''}</TableCell>
									<TableCell>{step.writeCnt ?? ''}</TableCell>
									<TableCell>{step.commitCnt ?? ''}</TableCell>
									<TableCell>{step.rollBack ?? ''}</TableCell>
									<TableCell>{step.lastExecDuration ?? ''}</TableCell>
									<TableCell>{step.status ?? ''}</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={7} align="center" sx={{ fontWeight: "bold" }}>
									No results found
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>


			<Box display="flex" justifyContent="center" mt={2}>
				<Button variant="outlined" color="primary" onClick={handleBackJobExec}>
					Back
				</Button>
			</Box>
		</>
	);
};

export default ExecDtlTable;
